'use client'

import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'

interface CookieConsentProps {
  isVisible: boolean
  onAccept: () => void
}

const CookieConsent: React.FC<CookieConsentProps> = ({ isVisible, onAccept }) => {
  const [isShown, setIsShown] = useState(false)

  useEffect(() => {
    if (isVisible) {
      // Небольшая задержка для плавного появления
      const timer = setTimeout(() => {
        setIsShown(true)
      }, 100)
      return () => clearTimeout(timer)
    } else {
      setIsShown(false)
    }
  }, [isVisible])

  if (!isVisible) return null

  return (
    <div 
      className={styles.cookieConsent}
      style={{
        transform: isShown ? 'translateY(0)' : 'translateY(100%)',
        opacity: isShown ? 1 : 0,
      }}
    >
      <div className={styles.cookieContent}>
        {/* Text */}
        <p className={styles.cookieText}>
          Мы используем файлы <span className={styles.cookiesWord}>cookies</span>. чтобы сделать наш сайт удобнее
        </p>
        
        {/* Button */}
        <button 
          onClick={onAccept}
          className={styles.cookieButton}
        >
          Принять и закрыть
        </button>
      </div>
    </div>
  )
}

CookieConsent.displayName = 'CookieConsent'

export default CookieConsent
